module.exports = __webpack_public_path__ + "media/images/ringrevenue/button_left_wrench-f7a274050fc7078a3490a2e3e5f807d8.png";